export const CHARMED_SCHOOLBUS = 'charmedSchoolbus'
